var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blinker",domProps:{"innerHTML":_vm._s(_vm.typedText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }